import React from 'react';
import { shallowEqual } from 'react-redux';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';

import ChatADBanner from './chatItem/ChatADBanner';
import ChatADFloating from './chatItem/ChatADFloating';
import ChatCustomBanner from './chatItem/ChatCustomBanner';

// 채팅 플레이 중 배너 모음
const ChatBanner = () => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const { endingPopupInfo } = useChatPlayContext();
  return (
    <>
      <ChatADFloating />
      {endingPopupInfo && playChapterInfo?.chapterOption && <ChatADBanner />}
      {endingPopupInfo && <ChatCustomBanner />}
    </>
  );
};

export default ChatBanner;
